const countries = [
    {
        "name": "United States",
        "dial_code": "+1",
        "currency": "USD",
        "country_iso": "EN"
    },
    {
        "name": "Afghanistan",
        "dial_code": "+93",
        "currency": "AFN",
        "country_iso": "AF"
    },
    {
        "name": "Albania",
        "dial_code": "+355",
        "currency": "ALL",
        "country_iso": "AL"
    },
    {
        "name": "Algeria",
        "dial_code": "+213",
        "currency": "DZD",
        "country_iso": "DZ"
    },
    {
        "name": "Andorra",
        "dial_code": "+376",
        "currency": "EUR",
        "country_iso": "AD"
    },
    {
        "name": "Angola",
        "dial_code": "+244",
        "currency": "AOA",
        "country_iso": "AO"
    },
    {
        "name": "Anguilla",
        "dial_code": "+1264",
        "currency": "XCD",
        "country_iso": "AI"
    },
    {
        "name": "Antigua",
        "dial_code": "+1268",
        "currency": "XCD",
        "country_iso": "AG"
    },
    {
        "name": "Argentina",
        "dial_code": "+54",
        "currency": "ARS",
        "country_iso": "AR"
    },
    {
        "name": "Armenia",
        "dial_code": "+374",
        "currency": "AMD",
        "country_iso": "AM"
    },
    {
        "name": "Aruba",
        "dial_code": "+297",
        "currency": "AWG",
        "country_iso": "AW"
    },
    {
        "name": "Australia",
        "dial_code": "+61",
        "currency": "AUD",
        "country_iso": "AU"
    },
    {
        "name": "Austria",
        "dial_code": "+43",
        "currency": "EUR",
        "country_iso": "AT"
    },
    {
        "name": "Azerbaijan",
        "dial_code": "+994",
        "currency": "AZN",
        "country_iso": "AZ"
    },
    {
        "name": "Bahrain",
        "dial_code": "+973",
        "currency": "BHD",
        "country_iso": "BH"
    },
    {
        "name": "Bangladesh",
        "dial_code": "+880",
        "currency": "BDT",
        "country_iso": "BD"
    },
    {
        "name": "Barbados",
        "dial_code": "+1246",
        "currency": "BBD",
        "country_iso": "BB"
    },
    {
        "name": "Belarus",
        "dial_code": "+375",
        "currency": "BYR",
        "country_iso": "BY"
    },
    {
        "name": "Belgium",
        "dial_code": "+32",
        "currency": "EUR",
        "country_iso": "BE"
    },
    {
        "name": "Belize",
        "dial_code": "+501",
        "currency": "BZD",
        "country_iso": "BZ"
    },
    {
        "name": "Benin",
        "dial_code": "+229",
        "currency": "XOF",
        "country_iso": "BJ"
    },
    {
        "name": "Bermuda",
        "dial_code": "+1441",
        "currency": "BMD",
        "country_iso": "BM"
    },
    {
        "name": "Bhutan",
        "dial_code": "+975",
        "currency": "BTN",
        "country_iso": "BT"
    },
    {
        "name": "Bolivia",
        "dial_code": "+591",
        "currency": "BOB",
        "country_iso": "BO"
    },
    {
        "name": "Bosnia and Herzegovina",
        "dial_code": "+387",
        "currency": "BAM",
        "country_iso": "BA"
    },
    {
        "name": "Botswana",
        "dial_code": "+267",
        "currency": "BWP",
        "country_iso": "BW"
    },
    {
        "name": "Brazil",
        "dial_code": "+55",
        "currency": "BRL",
        "country_iso": "BR"
    },
    {
        "name": "British Indian Ocean Territory",
        "dial_code": "+246",
        "currency": "USD",
        "country_iso": "IO"
    },
    {
        "name": "Brunei",
        "dial_code": "+673",
        "currency": "BND",
        "country_iso": "BN"
    },
    {
        "name": "Bulgaria",
        "dial_code": "+359",
        "currency": "BGN",
        "country_iso": "BG"
    },
    {
        "name": "Burkina Faso",
        "dial_code": "+226",
        "currency": "XOF",
        "country_iso": "BF"
    },
    {
        "name": "Burundi",
        "dial_code": "+257",
        "currency": "BIF",
        "country_iso": "BI"
    },
    {
        "name": "Cambodia",
        "dial_code": "+855",
        "currency": "KHR",
        "country_iso": "KH"
    },
    {
        "name": "Cameroon",
        "dial_code": "+237",
        "currency": "XAF",
        "country_iso": "CM"
    },
    {
        "name": "Canada",
        "dial_code": "+1",
        "currency": "CAD",
        "country_iso": "CA"
    },
    {
        "name": "Cape Verde",
        "dial_code": "+238",
        "currency": "CVE",
        "country_iso": "CV"
    },
    {
        "name": "Cayman Islands",
        "dial_code": "+1345",
        "currency": "KYD",
        "country_iso": "KY"
    },
    {
        "name": "Central African Republic",
        "dial_code": "+236",
        "currency": "XAF",
        "country_iso": "CF"
    },
    {
        "name": "Chad",
        "dial_code": "+235",
        "currency": "XAF",
        "country_iso": "TD"
    },
    {
        "name": "Chile",
        "dial_code": "+56",
        "currency": "CLP",
        "country_iso": "CL"
    },
    {
        "name": "China",
        "dial_code": "+86",
        "currency": "CNY",
        "country_iso": "CN"
    },
    {
        "name": "Colombia",
        "dial_code": "+57",
        "currency": "COP",
        "country_iso": "CO"
    },
    {
        "name": "Comoros",
        "dial_code": "+269",
        "currency": "KMF",
        "country_iso": "KM"
    },
    {
        "name": "Cook Islands",
        "dial_code": "+682",
        "currency": "NZD",
        "country_iso": "CK"
    },
    {
        "name": "Costa Rica",
        "dial_code": "+506",
        "currency": "CRC",
        "country_iso": "CR"
    },
    {
        "name": "Côte d'Ivoire",
        "dial_code": "+225",
        "currency": "XOF",
        "country_iso": "CI"
    },
    {
        "name": "Croatia",
        "dial_code": "+385",
        "currency": "HRK",
        "country_iso": "HR"
    },
    {
        "name": "Cuba",
        "dial_code": "+53",
        "currency": "CUP",
        "country_iso": "CU"
    },
    {
        "name": "Cyprus",
        "dial_code": "+357",
        "currency": "EUR",
        "country_iso": "CY"
    },
    {
        "name": "Czech Republic",
        "dial_code": "+420",
        "currency": "CZK",
        "country_iso": "CZ"
    },
    {
        "name": "Democratic Republic of Congo",
        "dial_code": "+243",
        "currency": "CDF",
        "country_iso": "CD"
    },
    {
        "name": "Denmark",
        "dial_code": "+45",
        "currency": "DKK",
        "country_iso": "DK"
    },
    {
        "name": "Djibouti",
        "dial_code": "+253",
        "currency": "DJF",
        "country_iso": "DJ"
    },
    {
        "name": "Dominica",
        "dial_code": "+1809",
        "currency": "XCD",
        "country_iso": "DM"
    },
    {
        "name": "Dominican Republic",
        "dial_code": "+1809",
        "currency": "DOP",
        "country_iso": "DO"
    },
    {
        "name": "Ecuador",
        "dial_code": "+593",
        "currency": "USD",
        "country_iso": "EC"
    },
    {
        "name": "Egypt",
        "dial_code": "+20",
        "currency": "EGP",
        "country_iso": "EG"
    },
    {
        "name": "El Salvador",
        "dial_code": "+503",
        "currency": "SVC",
        "country_iso": "SV"
    },
    {
        "name": "Equatorial Guinea",
        "dial_code": "+240",
        "currency": "XAF",
        "country_iso": "GQ"
    },
    {
        "name": "Eritrea",
        "dial_code": "+291",
        "currency": "ERN",
        "country_iso": "ER"
    },
    {
        "name": "Estonia",
        "dial_code": "+372",
        "currency": "EUR",
        "country_iso": "EE"
    },
    {
        "name": "Ethiopia",
        "dial_code": "+251",
        "currency": "ETB",
        "country_iso": "ET"
    },
    {
        "name": "Falkland Islands",
        "dial_code": "+500",
        "currency": "FKP",
        "country_iso": "FK"
    },
    {
        "name": "Faroe Islands",
        "dial_code": "+298",
        "currency": "DKK",
        "country_iso": "FO"
    },
    {
        "name": "Federated States of Micronesia",
        "dial_code": "+691",
        "currency": "USD",
        "country_iso": "FM"
    },
    {
        "name": "Fiji",
        "dial_code": "+679",
        "currency": "FJD",
        "country_iso": "FJ"
    },
    {
        "name": "Finland",
        "dial_code": "+358",
        "currency": "EUR",
        "country_iso": "FI"
    },
    {
        "name": "France",
        "dial_code": "+33",
        "currency": "EUR",
        "country_iso": "FR"
    },
    {
        "name": "French Guiana",
        "dial_code": "+594",
        "currency": "EUR",
        "country_iso": "GF"
    },
    {
        "name": "French Polynesia",
        "dial_code": "+689",
        "currency": "XPF",
        "country_iso": "PF"
    },
    {
        "name": "Gabon",
        "dial_code": "+241",
        "currency": "XAF",
        "country_iso": "GA"
    },
    {
        "name": "Georgia",
        "dial_code": "+995",
        "currency": "GEL",
        "country_iso": "GE"
    },
    {
        "name": "Germany",
        "dial_code": "+49",
        "currency": "EUR",
        "country_iso": "DE"
    },
    {
        "name": "Ghana",
        "dial_code": "+233",
        "currency": "GHC",
        "country_iso": "GH"
    },
    {
        "name": "Gibraltar",
        "dial_code": "+350",
        "currency": "GIP",
        "country_iso": "GI"
    },
    {
        "name": "Greece",
        "dial_code": "+30",
        "currency": "EUR",
        "country_iso": "GR"
    },
    {
        "name": "Greenland",
        "dial_code": "+299",
        "currency": "DKK",
        "country_iso": "GL"
    },
    {
        "name": "Grenada",
        "dial_code": "+1473",
        "currency": "XCD",
        "country_iso": "GD"
    },
    {
        "name": "Guadeloupe",
        "dial_code": "+590",
        "currency": "EUR",
        "country_iso": "GP"
    },
    {
        "name": "Guam",
        "dial_code": "+671",
        "currency": "USD",
        "country_iso": "GU"
    },
    {
        "name": "Guatemala",
        "dial_code": "+502",
        "currency": "GTQ",
        "country_iso": "GT"
    },
    {
        "name": "Guinea",
        "dial_code": "+224",
        "currency": "GNF",
        "country_iso": "GN"
    },
    {
        "name": "Guinea-Bissau",
        "dial_code": "+245",
        "currency": "GWP",
        "country_iso": "GW"
    },
    {
        "name": "Guyana",
        "dial_code": "+592",
        "currency": "GYD",
        "country_iso": "GY"
    },
    {
        "name": "Haiti",
        "dial_code": "+509",
        "currency": "HTG",
        "country_iso": "HT"
    },
    {
        "name": "Honduras",
        "dial_code": "+504",
        "currency": "HNL",
        "country_iso": "HN"
    },
    {
        "name": "Hong Kong",
        "dial_code": "+852",
        "currency": "HKD",
        "country_iso": "HK"
    },
    {
        "name": "Hungary",
        "dial_code": "+36",
        "currency": "HUF",
        "country_iso": "HU"
    },
    {
        "name": "Iceland",
        "dial_code": "+354",
        "currency": "ISK",
        "country_iso": "IS"
    },
    {
        "name": "India",
        "dial_code": "+91",
        "currency": "INR",
        "country_iso": "IN"
    },
    {
        "name": "Indonesia",
        "dial_code": "+62",
        "currency": "IDR",
        "country_iso": "ID"
    },
    {
        "name": "Iran",
        "dial_code": "+98",
        "currency": "IRR",
        "country_iso": "IR"
    },
    {
        "name": "Iraq",
        "dial_code": "+964",
        "currency": "IQD",
        "country_iso": "IQ"
    },
    {
        "name": "Ireland",
        "dial_code": "+353",
        "currency": "EUR",
        "country_iso": "IE"
    },
    {
        "name": "Israel",
        "dial_code": "+972",
        "currency": "ILS",
        "country_iso": "IL"
    },
    {
        "name": "Italy",
        "dial_code": "+39",
        "currency": "EUR",
        "country_iso": "IT"
    },
    {
        "name": "Jamaica",
        "dial_code": "+1876",
        "currency": "JMD",
        "country_iso": "JM"
    },
    {
        "name": "Japan",
        "dial_code": "+81",
        "currency": "JPY",
        "country_iso": "JP"
    },
    {
        "name": "Jordan",
        "dial_code": "+962",
        "currency": "JOD",
        "country_iso": "JO"
    },
    {
        "name": "Kazakhstan",
        "dial_code": "+7",
        "currency": "KZT",
        "country_iso": "KZ"
    },
    {
        "name": "Kenya",
        "dial_code": "+254",
        "currency": "KES",
        "country_iso": "KE"
    },
    {
        "name": "Kiribati",
        "dial_code": "+686",
        "currency": "AUD",
        "country_iso": "KI"
    },
    {
        "name": "Kosovo",
        "dial_code": "+381",
        "currency": "EUR",
        "country_iso": "XK"
    },
    {
        "name": "Kuwait",
        "dial_code": "+965",
        "currency": "KWD",
        "country_iso": "KW"
    },
    {
        "name": "Kyrgyzstan",
        "dial_code": "+996",
        "currency": "KGS",
        "country_iso": "KG"
    },
    {
        "name": "Laos",
        "dial_code": "+856",
        "currency": "LAK",
        "country_iso": "LA"
    },
    {
        "name": "Latvia",
        "dial_code": "+371",
        "currency": "EUR",
        "country_iso": "LV"
    },
    {
        "name": "Lebanon",
        "dial_code": "+961",
        "currency": "LBP",
        "country_iso": "LB"
    },
    {
        "name": "Lesotho",
        "dial_code": "+266",
        "currency": "LSL",
        "country_iso": "LS"
    },
    {
        "name": "Liberia",
        "dial_code": "+231",
        "currency": "LRD",
        "country_iso": "LR"
    },
    {
        "name": "Libya",
        "dial_code": "+218",
        "currency": "LYD",
        "country_iso": "LY"
    },
    {
        "name": "Liechtenstein",
        "dial_code": "+423",
        "currency": "CHF",
        "country_iso": "LI"
    },
    {
        "name": "Lithuania",
        "dial_code": "+370",
        "currency": "EUR",
        "country_iso": "LT"
    },
    {
        "name": "Luxembourg",
        "dial_code": "+352",
        "currency": "EUR",
        "country_iso": "LU"
    },
    {
        "name": "Macau",
        "dial_code": "+853",
        "currency": "MOP",
        "country_iso": "MO"
    },
    {
        "name": "Macedonia",
        "dial_code": "+389",
        "currency": "MKD",
        "country_iso": "MK"
    },
    {
        "name": "Madagascar",
        "dial_code": "+261",
        "currency": "MGF",
        "country_iso": "MG"
    },
    {
        "name": "Malawi",
        "dial_code": "+265",
        "currency": "MWK",
        "country_iso": "MW"
    },
    {
        "name": "Malaysia",
        "dial_code": "+60",
        "currency": "MYR",
        "country_iso": "MY"
    },
    {
        "name": "Maldives",
        "dial_code": "+960",
        "currency": "MVR",
        "country_iso": "MV"
    },
    {
        "name": "Mali",
        "dial_code": "+223",
        "currency": "XOF",
        "country_iso": "ML"
    },
    {
        "name": "Malta",
        "dial_code": "+356",
        "currency": "MTL",
        "country_iso": "MT"
    },
    {
        "name": "Marshall Islands",
        "dial_code": "+692",
        "currency": "USD",
        "country_iso": "MH"
    },
    {
        "name": "Martinique",
        "dial_code": "+596",
        "currency": "EUR",
        "country_iso": "MQ"
    },
    {
        "name": "Mauritania",
        "dial_code": "+222",
        "currency": "MRO",
        "country_iso": "MR"
    },
    {
        "name": "Mauritius",
        "dial_code": "+230",
        "currency": "MUR",
        "country_iso": "MU"
    },
    {
        "name": "Mayotte",
        "dial_code": "+262",
        "currency": "EUR",
        "country_iso": "YT"
    },
    {
        "name": "Mexico",
        "dial_code": "+52",
        "currency": "MXN",
        "country_iso": "MX"
    },
    {
        "name": "Moldova",
        "dial_code": "+373",
        "currency": "MDL",
        "country_iso": "MD"
    },
    {
        "name": "Monaco",
        "dial_code": "+377",
        "currency": "EUR",
        "country_iso": "MC"
    },
    {
        "name": "Mongolia",
        "dial_code": "+976",
        "currency": "MNT",
        "country_iso": "MN"
    },
    {
        "name": "Montenegro",
        "dial_code": "+382",
        "currency": "EUR",
        "country_iso": "ME"
    },
    {
        "name": "Montserrat",
        "dial_code": "+1664",
        "currency": "XCD",
        "country_iso": "MS"
    },
    {
        "name": "Morocco",
        "dial_code": "+212",
        "currency": "MAD",
        "country_iso": "MA"
    },
    {
        "name": "Mozambique",
        "dial_code": "+258",
        "currency": "MZM",
        "country_iso": "MZ"
    },
    {
        "name": "Myanmar",
        "dial_code": "+95",
        "currency": "MMK",
        "country_iso": "MM"
    },
    {
        "name": "Namibia",
        "dial_code": "+264",
        "currency": "ZAR",
        "country_iso": "NA"
    },
    {
        "name": "Nauru",
        "dial_code": "+674",
        "currency": "AUD",
        "country_iso": "NR"
    },
    {
        "name": "Nepal",
        "dial_code": "+977",
        "currency": "NPR",
        "country_iso": "NP"
    },
    {
        "name": "Netherlands",
        "dial_code": "+31",
        "currency": "EUR",
        "country_iso": "NL"
    },
    {
        "name": "Netherlands Antilles",
        "dial_code": "+599",
        "currency": "ANG",
        "country_iso": "AN"
    },
    {
        "name": "New Caledonia",
        "dial_code": "+687",
        "currency": "XPF",
        "country_iso": "NC"
    },
    {
        "name": "New Zealand",
        "dial_code": "+64",
        "currency": "NZD",
        "country_iso": "NZ"
    },
    {
        "name": "Nicaragua",
        "dial_code": "+505",
        "currency": "NIO",
        "country_iso": "NI"
    },
    {
        "name": "Niger",
        "dial_code": "+227",
        "currency": "XOF",
        "country_iso": "NE"
    },
    {
        "name": "Nigeria",
        "dial_code": "+234",
        "currency": "NGN",
        "country_iso": "NG"
    },
    {
        "name": "Niue",
        "dial_code": "+683",
        "currency": "NZD",
        "country_iso": "NU"
    },
    {
        "name": "Norfolk Island",
        "dial_code": "+672",
        "currency": "AUD",
        "country_iso": "NF"
    },
    {
        "name": "North Korea",
        "dial_code": "+850",
        "currency": "KPW",
        "country_iso": "KP"
    },
    {
        "name": "Northern Mariana Islands",
        "dial_code": "+670",
        "currency": "USD",
        "country_iso": "MP"
    },
    {
        "name": "Norway",
        "dial_code": "+47",
        "currency": "NOK",
        "country_iso": "NO"
    },
    {
        "name": "Oman",
        "dial_code": "+968",
        "currency": "OMR",
        "country_iso": "OM"
    },
    {
        "name": "Pakistan",
        "dial_code": "+92",
        "currency": "PKR",
        "country_iso": "PK"
    },
    {
        "name": "Palau",
        "dial_code": "+680",
        "currency": "USD",
        "country_iso": "PW"
    },
    {
        "name": "Palestine",
        "dial_code": "+970",
        "currency": "EGP",
        "country_iso": "PS"
    },
    {
        "name": "Panama",
        "dial_code": "+507",
        "currency": "PAB",
        "country_iso": "PA"
    },
    {
        "name": "Papua New Guinea",
        "dial_code": "+675",
        "currency": "PGK",
        "country_iso": "PG"
    },
    {
        "name": "Paraguay",
        "dial_code": "+595",
        "currency": "PYG",
        "country_iso": "PY"
    },
    {
        "name": "Peru",
        "dial_code": "+51",
        "currency": "PEN",
        "country_iso": "PE"
    },
    {
        "name": "Philippines",
        "dial_code": "+63",
        "currency": "PHP",
        "country_iso": "PH"
    },
    {
        "name": "Poland",
        "dial_code": "+48",
        "currency": "PLN",
        "country_iso": "PL"
    },
    {
        "name": "Portugal",
        "dial_code": "+351",
        "currency": "EUR",
        "country_iso": "PT"
    },
    {
        "name": "Puerto Rico",
        "dial_code": "+1787",
        "currency": "USD",
        "country_iso": "PR"
    },
    {
        "name": "Qatar",
        "dial_code": "+974",
        "currency": "QAR",
        "country_iso": "QA"
    },
    {
        "name": "Republic of the Congo",
        "dial_code": "+242",
        "currency": "XAF",
        "country_iso": "CG"
    },
    {
        "name": "Réunion",
        "dial_code": "+262",
        "currency": "EUR",
        "country_iso": "RE"
    },
    {
        "name": "Romania",
        "dial_code": "+40",
        "currency": "ROL",
        "country_iso": "RO"
    },
    {
        "name": "Russia",
        "dial_code": "+7",
        "currency": "RUB",
        "country_iso": "RU"
    },
    {
        "name": "Rwanda",
        "dial_code": "+250",
        "currency": "RWF",
        "country_iso": "RW"
    },
    {
        "name": "Saint Helena",
        "dial_code": "+290",
        "currency": "SHP",
        "country_iso": "SH"
    },
    {
        "name": "Samoa",
        "dial_code": "+685",
        "currency": "WST",
        "country_iso": "WS"
    },
    {
        "name": "San Marino",
        "dial_code": "+378",
        "currency": "EUR",
        "country_iso": "SM"
    },
    {
        "name": "São Tomé and Príncipe",
        "dial_code": "+239",
        "currency": "STD",
        "country_iso": "ST"
    },
    {
        "name": "Saudi Arabia",
        "dial_code": "+966",
        "currency": "SAR",
        "country_iso": "SA"
    },
    {
        "name": "Senegal",
        "dial_code": "+221",
        "currency": "XOF",
        "country_iso": "SN"
    },
    {
        "name": "Serbia",
        "dial_code": "+381",
        "currency": "CSD",
        "country_iso": "RS"
    },
    {
        "name": "Seychelles",
        "dial_code": "+248",
        "currency": "SCR",
        "country_iso": "SC"
    },
    {
        "name": "Sierra Leone",
        "dial_code": "+232",
        "currency": "SLL",
        "country_iso": "SL"
    },
    {
        "name": "Singapore",
        "dial_code": "+65",
        "currency": "SGD",
        "country_iso": "SG"
    },
    {
        "name": "Slovakia",
        "dial_code": "+421",
        "currency": "EUR",
        "country_iso": "SK"
    },
    {
        "name": "Slovenia",
        "dial_code": "+386",
        "currency": "EUR",
        "country_iso": "SI"
    },
    {
        "name": "Solomon Islands",
        "dial_code": "+677",
        "currency": "SBD",
        "country_iso": "SB"
    },
    {
        "name": "Somalia",
        "dial_code": "+252",
        "currency": "SOS",
        "country_iso": "SO"
    },
    {
        "name": "South Africa",
        "dial_code": "+27",
        "currency": "ZAR",
        "country_iso": "ZA"
    },
    {
        "name": "South Korea",
        "dial_code": "+82",
        "currency": "KRW",
        "country_iso": "KR"
    },
    {
        "name": "Spain",
        "dial_code": "+34",
        "currency": "EUR",
        "country_iso": "ES"
    },
    {
        "name": "Sri Lanka",
        "dial_code": "+94",
        "currency": "LKR",
        "country_iso": "LK"
    },
    {
        "name": "St. Lucia",
        "dial_code": "+1758",
        "currency": "XCD",
        "country_iso": "LC"
    },
    {
        "name": "Sudan",
        "dial_code": "+249",
        "currency": "SDG",
        "country_iso": "SD"
    },
    {
        "name": "Suriname",
        "dial_code": "+597",
        "currency": "SRG",
        "country_iso": "SR"
    },
    {
        "name": "Swaziland",
        "dial_code": "+268",
        "currency": "SZL",
        "country_iso": "SZ"
    },
    {
        "name": "Sweden",
        "dial_code": "+46",
        "currency": "SEK",
        "country_iso": "SE"
    },
    {
        "name": "Switzerland",
        "dial_code": "+41",
        "currency": "CHF",
        "country_iso": "CH"
    },
    {
        "name": "Syria",
        "dial_code": "+963",
        "currency": "SYP",
        "country_iso": "SY"
    },
    {
        "name": "Taiwan",
        "dial_code": "+886",
        "currency": "TWD",
        "country_iso": "TW"
    },
    {
        "name": "Tajikistan",
        "dial_code": "+992",
        "currency": "TJS",
        "country_iso": "TJ"
    },
    {
        "name": "Tanzania",
        "dial_code": "+255",
        "currency": "TZS",
        "country_iso": "TZ"
    },
    {
        "name": "Thailand",
        "dial_code": "+66",
        "currency": "THB",
        "country_iso": "TH"
    },
    {
        "name": "The Bahamas",
        "dial_code": "+1242",
        "currency": "USD",
        "country_iso": "BS"
    },
    {
        "name": "The Gambia",
        "dial_code": "+220",
        "currency": "GMD",
        "country_iso": "GM"
    },
    {
        "name": "Timor-Leste",
        "dial_code": "+670",
        "currency": "USD",
        "country_iso": "TL"
    },
    {
        "name": "Togo",
        "dial_code": "+228",
        "currency": "XOF",
        "country_iso": "TG"
    },
    {
        "name": "Tokelau",
        "dial_code": "+690",
        "currency": "NZD",
        "country_iso": "TK"
    },
    {
        "name": "Tonga",
        "dial_code": "+676",
        "currency": "TOP",
        "country_iso": "TO"
    },
    {
        "name": "Trinidad and Tobago",
        "dial_code": "+1868",
        "currency": "TTD",
        "country_iso": "TT"
    },
    {
        "name": "Tunisia",
        "dial_code": "+216",
        "currency": "TND",
        "country_iso": "TN"
    },
    {
        "name": "Turkey",
        "dial_code": "+90",
        "currency": "TRY",
        "country_iso": "TR"
    },
    {
        "name": "Turkmenistan",
        "dial_code": "+993",
        "currency": "TMM",
        "country_iso": "TM"
    },
    {
        "name": "Turks and Caicos Islands",
        "dial_code": "+1649",
        "currency": "USD",
        "country_iso": "TC"
    },
    {
        "name": "Tuvalu",
        "dial_code": "+688",
        "currency": "AUD",
        "country_iso": "TV"
    },
    {
        "name": "Uganda",
        "dial_code": "+256",
        "currency": "UGX",
        "country_iso": "UG"
    },
    {
        "name": "Ukraine",
        "dial_code": "+380",
        "currency": "UAH",
        "country_iso": "UA"
    },
    {
        "name": "United Arab Emirates",
        "dial_code": "+971",
        "currency": "AED",
        "country_iso": "AE"
    },
    {
        "name": "United Kingdom",
        "dial_code": "+44",
        "currency": "GBP",
        "country_iso": "GB"
    },
    {
        "name": "Uruguay",
        "dial_code": "+598",
        "currency": "UYU",
        "country_iso": "UY"
    },
    {
        "name": "US Virgin Islands",
        "dial_code": "+1340",
        "currency": "USD",
        "country_iso": "VI"
    },
    {
        "name": "Uzbekistan",
        "dial_code": "+998",
        "currency": "UZS",
        "country_iso": "UZ"
    },
    {
        "name": "Vanuatu",
        "dial_code": "+678",
        "currency": "VUV",
        "country_iso": "VU"
    },
    {
        "name": "Vatican City",
        "dial_code": "+39",
        "currency": "EUR",
        "country_iso": "VA"
    },
    {
        "name": "Venezuela",
        "dial_code": "+58",
        "currency": "VEF",
        "country_iso": "VE"
    },
    {
        "name": "Vietnam",
        "dial_code": "+84",
        "currency": "VND",
        "country_iso": "VN"
    },
    {
        "name": "Wallis and Futuna",
        "dial_code": "+681",
        "currency": "XPF",
        "country_iso": "WF"
    },
    {
        "name": "Yemen",
        "dial_code": "+967",
        "currency": "YER",
        "country_iso": "YE"
    },
    {
        "name": "Zambia",
        "dial_code": "+260",
        "currency": "ZMK",
        "country_iso": "ZM"
    },
    {
        "name": "Zimbabwe",
        "dial_code": "+263",
        "currency": "ZWD",
        "country_iso": "ZW"
    }
]
export default countries;